import apis from '../../modules/apis'
import { axiosPost } from '../axiosHelper'

export const sleep = (time) => {
  return new Promise((resolve) => setTimeout(resolve, time))
}

export const saveTutor = async ({ tutorId, isAdd, type = null }) => {
  //  Time First
  const T_FAVORITE = 't-favorite'
  const T_RECOMMEND = 't-recommend'
  const T_ALL = 't-all'

  //  Tutor First
  const P_FAVORITE = 'p-favorite'
  const P_RECOMMEND = 'p-recommend'
  const P_AVAILABLE = 'p-available'

  let referrer = ''
  switch (type) {
    case T_FAVORITE:
      referrer = 'lesson/schedule/time/favorite'
      break
    case T_RECOMMEND:
      referrer = 'lesson/schedule/time/featured'
      break
    case T_ALL:
      referrer = 'lesson/schedule/time/available'
      break
    case P_FAVORITE:
      referrer = 'lesson/schedule/tutor/favorite'
      break
    case P_RECOMMEND:
      referrer = 'lesson/schedule/tutor/featured'
      break
    case P_AVAILABLE:
      referrer = 'lesson/schedule/tutor/available'
      break
    default:
      referrer = 'etc'
  }

  const urls = isAdd ? apis.tutor.add() : apis.tutor.delete()
  const res = await axiosPost(urls, {
    tutor_id: tutorId,
    referrer,
  })
  return res
}
